import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import workingHoursFormatter from '../services/formatWorkingHours';
import { getGmtOffset } from '../utils/timezoneUtils';

const WorkingHours = ({ workingHours, country }) => {
    const formattedWorkHours = workingHoursFormatter(workingHours, country);
    const gmtOffset = getGmtOffset(country);

    return (
        <Fragment>
            <span className="icon-clock" />
            <span>{formattedWorkHours}{gmtOffset}</span>
        </Fragment>
    );
};

WorkingHours.defaultProps = {
    workingHours: {
        weekday_start: null,
        weekend_end: null,
    },
    country: null,
};

WorkingHours.propTypes = {
    workingHours: PropTypes.shape({
        workday_start: PropTypes.number.isRequired,
        workday_end: PropTypes.number.isRequired,
        weekend_start: PropTypes.number,
        weekend_end: PropTypes.number,
    }),
    country: PropTypes.string,
};

export default WorkingHours;
